import type { Location } from '@remix-run/router';
import { homeBreadcrumb } from 'slovlex-idsk-react-components';
import routes from '../../routing/routes';
import NavrhAktuEu from '../../model/NavrhAktuEu';

const defaultBreadcrumb = [
  homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
  {
    heading: routes.navrhyAktovEu.list.name,
    to: routes.navrhyAktovEu.list.to,
  }];

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getRouteList = (aktEuDetail: NavrhAktuEu, currentLocation: Location) => {
  if (aktEuDetail) {
    return [
      ...defaultBreadcrumb,
      {
        heading: aktEuDetail?.aktId,
        to: currentLocation.pathname,
      }];
  }

  return defaultBreadcrumb;
};

export default getRouteList;
